module.exports = __webpack_public_path__ + "static/media/linkedincertificateLogo.8dbc15e6.png";